var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFeedbackBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 33C48.9086 33 31 50.9086 31 73V452.451C31 464.888 46.0068 471.15 54.8473 462.402L146.204 372H429C451.091 372 469 354.091 469 332V73C469 50.9086 451.091 33 429 33H71Z",
    fill: "#062134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131 143H369",
    stroke: "white",
    strokeWidth: 24,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131 203H369",
    stroke: "white",
    strokeWidth: 24,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131 263H311",
    stroke: "white",
    strokeWidth: 24,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFeedbackBlue);
export default __webpack_public_path__ + "static/media/ico_feedback_blue.5f353489373ed7c6378adaef709c9c75.svg";
export { ForwardRef as ReactComponent };